import React from 'react';
import PropTypes from 'prop-types';
import AlertMessage from './AlertMessage';

const ErrorMessage = ({ error = '', dismissable = true }) => {
  return (
    <div className="error-box">
      {error && <AlertMessage type="danger" text={error.toString()} tag="Error" dismissable={dismissable} />}
    </div>
  );
};

ErrorMessage.propTypes = {
  error: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  dismissable: PropTypes.bool
};

export default ErrorMessage;
